function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 2,
  fill: "#F3F3F3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8562 7.69066L8.38471 2.15815C8.28244 2.05678 8.14493 2 8.00171 2C7.85849 2 7.72099 2.05678 7.61871 2.15815L2.14725 7.69066C2.07673 7.76702 2.02904 7.862 2.00969 7.96463C1.99033 8.06725 2.00011 8.17332 2.03789 8.27056C2.07567 8.3678 2.13991 8.45223 2.22317 8.5141C2.30643 8.57596 2.40531 8.61272 2.50837 8.62012H3.17589V14.1526C3.17589 14.2994 3.23353 14.4401 3.33614 14.5438C3.43875 14.6476 3.57792 14.7059 3.72303 14.7059H6.78705V10.9936C6.78705 10.8468 6.84469 10.7061 6.9473 10.6024C7.04991 10.4986 7.18908 10.4403 7.33419 10.4403H8.65829C8.8034 10.4403 8.94257 10.4986 9.04518 10.6024C9.14779 10.7061 9.20543 10.8468 9.20543 10.9936V14.7003H12.2694C12.4146 14.7003 12.5537 14.6421 12.6563 14.5383C12.7589 14.4346 12.8166 14.2938 12.8166 14.1471V8.61459H13.5115C13.6121 8.60363 13.7077 8.56466 13.7878 8.50203C13.8678 8.43939 13.9291 8.35554 13.9648 8.2598C14.0005 8.16406 14.0093 8.06017 13.9901 7.9597C13.9709 7.85922 13.9246 7.76609 13.8562 7.69066Z",
  fill: "#292929"
});

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.39df3003.svg";
export { ForwardRef as ReactComponent };